import { COLOR_RED, COLOR_BLACK, TableElementFormatter, COLOR_ORANGE } from '../../shared/model/table-element-formatter';
import { DeviceStatus } from '../model/device-status';
import { AdditionalInfoImpl } from '../model/status/additional-info-impl';

export class StatusesTableFormatter implements TableElementFormatter<AdditionalInfoImpl> {

  createElementCssClasses = (deviceStatus: AdditionalInfoImpl): string => {
    const status = deviceStatus?.device?.status ?? DeviceStatus.UNKNOWN;

    if (status === DeviceStatus.ERROR)
      return COLOR_RED;

    if (status === DeviceStatus.WARNING)
      return COLOR_ORANGE;

    return COLOR_BLACK;
  };
}
